import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "edit_filled",
  width: "50",
  height: "50",
  viewBox: "0 0 13.626 15.897"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_2505",
  d: "m17.433 5.719.8.8.819-.819a1.137 1.137 0 0 0 0-1.608l-2.258-2.259a1.136 1.136 0 0 0-1.608 0l-.819.819.8.8z",
  class: "cls-1",
  transform: "translate(-5.762 -1.5)"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_2506",
  d: "m4.5 14.258.56-2.521L7.017 13.7zm10.172-6.306-.8-.8L11.6 4.885l-.8-.8-6.7 6.7L3 15.754l4.975-1.105z",
  class: "cls-1",
  transform: "translate(-3 -2.127)"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_2507",
  d: "M3 22.136h13.626V21H3z",
  class: "cls-1",
  transform: "translate(-3 -6.238)"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render };